// Base de URL para los canales SSE.
//
// Por qué existe: en HTTP/1.1 el navegador limita ~6 conexiones POR ORIGEN, y cada canal SSE
// ocupa una permanentemente. La app llega a abrir 8 canales, así que si todos comparten origen
// con la carga de la página y las llamadas normales, el pool se agota y CUALQUIER petición
// nueva (incluida recargar la página) se queda encolada hasta que algo cierre un stream.
//
// En desarrollo el dev-server hace de proxy (VUE_APP_SERVER_MOVILIDAD='/') para evitar CORS,
// lo que deja TODO —assets, API y SSE— en el mismo origen y agrava el problema. Con
// VUE_APP_SSE_MOVILIDAD apuntando directamente a la API (http://localhost:8091/) los SSE
// vuelven a un origen propio: la página y las llamadas normales ya no compiten con ellos.
//
// Sin la variable definida se comporta como antes (misma base que el resto), así que en
// producción —donde no hay proxy ni el tope duele igual, y sobre HTTP/2 ni aplica— no cambia nada.
//
// Arreglo de raíz pendiente: multiplexar todos los canales en UNA sola conexión.

/**
 * @param {string} baseNormal  la base que usa el adaptador (p. ej. Model.server_movilidad)
 * @returns {string} base a usar para abrir el stream SSE
 */
export function baseSse(baseNormal) {
    var propia = process.env.VUE_APP_SSE_MOVILIDAD;
    return propia && propia.length ? propia : baseNormal;
}

export default { baseSse };
